import { render } from "./CollectorSetup.vue?vue&type=template&id=77b79e02&scoped=true"
import script from "./CollectorSetup.vue?vue&type=script&lang=js"
export * from "./CollectorSetup.vue?vue&type=script&lang=js"

import "./CollectorSetup.vue?vue&type=style&index=0&id=77b79e02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b79e02"]])

export default __exports__